/**
 * 案件相关常量
 */

/** 非诉案件类型（enum_config CASE_TYPE 中的值） */
export const NON_LITIGATION_CASE_TYPE = '非诉';

/**
 * 是否为非诉案件
 *
 * 非诉案件不展示诉讼相关字段：开庭时间、判决日期、法院名称、法院联系方式。
 * 已填写的旧数据保留在库中，仅前端不渲染。
 */
export const isNonLitigation = (caseType?: string | null): boolean =>
  caseType === NON_LITIGATION_CASE_TYPE;
